/* eslint-disable react/prop-types */ // TODO: add props
import _ from 'lodash';

/** Components */
import EquationSolution from './EquationSolution';

const ComplexSolution = ({ response }) => {
  if (_.isEmpty(response)) {
    return <p>None submitted</p>;
  }

  // Equation
  if (!_.isEmpty(response.text_submitted_text)) {
    try {
      // Complex answers should be a json array of latex strings...
      const equations = JSON.parse(response.text_submitted_text);
      if (_.isArray(equations)) {
        return <EquationSolution response={response} equations={equations} />;
      }
      // Integers are valid json
      return <p>{response.text_submitted_text}</p>;
    } catch (e) {
      if (e instanceof SyntaxError) {
        // But old responses might just be text
        return <p>{response.text_submitted_text}</p>;
      }
      throw e;
    }
  }

  return <p>None submitted</p>;
};

export default ComplexSolution;
